import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AppService } from './app.service';
import { ADMIN_CONSTANT } from './app.model';
import { DashboardService } from './dashboard/dashboard.service';
import { DashboardResolver } from './dashboard/dashboard.resolver';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ActivateGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private service: AppService,
    private dashService: DashboardService,
    private dashResolver: DashboardResolver
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log(next, state);

    if (!this.service.adminConfig) {
      this.router.navigate(['offline'], {
        replaceUrl: true,
      });
      return false;
    }

    if (
      this.service.adminConfig.find(
        (r) =>
          r.ConfigCode === ADMIN_CONSTANT.SITE_UNDER_MAINTENANCE &&
          !!r.ConfigValue &&
          r.ConfigValue === 'TRUE'
      )
    ) {
      this.router.navigate(['maintenance'], {
        replaceUrl: true,
      });
      return false;
    }
    if (!this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_AUTH_TOKEN)) {
      this.router.navigate(['authentication'], {
        replaceUrl: true,
        queryParams: { redirectURL: `${state.url}` },
      });
      return false;
    }

    return true;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log("screen", next.data.screen);

    const _SCA = this.dashService.getScreenAccessCode(next.data.screen);   
    if (_SCA === 'NO') {
      if (!!window.history.state && window.history.state.navigationId === -1) {
        this.router.navigate(['dashboard'], {
          replaceUrl: true,
        });
      }
      return false;
    }

    return true;
  }
}
